import { InvestmentPathDetail, Mimshak, PolicyOrAccount, PolicyStatus, Product } from "../interfaces/DTO/mislaka_xml_models";
import { InvestmentPathType } from "../interfaces/DTO/investmentPathType";
import { ManualMimshakData } from "../interfaces/DTO/manualMimshakData";

export type PortfolioCurrency = "ILS" | "USD" | "EUR";

export const PORTFOLIO_CURRENCY_LABEL: Record<PortfolioCurrency, string> = {
  ILS: "שקלי",
  USD: "דולרי",
  EUR: "יורו",
};

const CURRENCY_PATH_NAME: Record<PortfolioCurrency, string> = {
  ILS: "",
  USD: "מט\"ח דולר",
  EUR: "מט\"ח יורו",
};

/**
 * מחלץ את המטבע מתוך data קיים של תיק השקעות ידני
 */
export const getPortfolioCurrencyFromData = (data: any): PortfolioCurrency => {
  const paths: InvestmentPathDetail[] = data?.products?.[0]?.policies_or_accounts?.[0]?.investment_paths ?? [];
  const foreignPath = paths.find((p) => p.path_code === InvestmentPathType.FOREIGN_CURRENCY);
  if (!foreignPath) return "ILS";
  return foreignPath.path_name?.includes("יורו") ? "EUR" : "USD";
};

/**
 * מחלץ את הסכום הזר מתוך data קיים של תיק השקעות ידני
 */
export const getForeignAmountFromData = (data: any): number => {
  const paths: InvestmentPathDetail[] = data?.products?.[0]?.policies_or_accounts?.[0]?.investment_paths ?? [];
  const foreignPath = paths.find((p) => p.path_code === InvestmentPathType.FOREIGN_CURRENCY);
  return foreignPath?.accumulated_amount ?? 0;
};

/**
 * יוצר PolicyOrAccount לתיק השקעות ידני
 */
const buildInvestmentPolicyOrAccount = (
  data: ManualMimshakData,
  currency: PortfolioCurrency,
  foreignAmount: number
): PolicyOrAccount => {
  const investmentPaths: InvestmentPathDetail[] =
    currency !== "ILS" && foreignAmount > 0
      ? [
          {
            path_code: InvestmentPathType.FOREIGN_CURRENCY,
            path_name: CURRENCY_PATH_NAME[currency],
            accumulated_amount: foreignAmount,
            management_fee_on_deposit: 0,
            management_fee_on_savings: 0,
          },
        ]
      : [];

  return {
    policy_number: data.policy_number,
    status: PolicyStatus.ACTIVE,
    update_date: data.reported_period,
    program_name: "",
    investment_paths: investmentPaths,
  } as any;
};

/**
 * יוצר Product לתיק השקעות ידני
 */
const buildInvestmentProduct = (
  data: ManualMimshakData,
  currency: PortfolioCurrency,
  foreignAmount: number
): Product => ({
  details: {
    producer_code: "",
    handler_code: data.handler_code,
    product_type: data.product_type,
  },
  policies_or_accounts: [buildInvestmentPolicyOrAccount(data, currency, foreignAmount)],
});

/**
 * יוצר Mimshak לתיק השקעות ידני עם תמיכה במטבע זר
 * @param data - נתוני תיק ההשקעות
 * @param currency - מטבע: "ILS" | "USD" | "EUR"
 * @param foreignAmount - הסכום במטבע הזר (0 אם שקלי)
 */
export const buildInvestmentPortfolioMimshak = (
  data: ManualMimshakData,
  currency: PortfolioCurrency,
  foreignAmount: number
): Mimshak => ({
  products: [buildInvestmentProduct(data, currency, foreignAmount)],
});
